module.exports = __webpack_public_path__ + "img/fieldwork-2018-lankao.33dccfa0.jpg";